import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';

const CustomTooltip = ({ placement, title, children }) => (
  <Tooltip placement={placement} title={title}>
    {children}
  </Tooltip>
);

CustomTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  placement: PropTypes.string.isRequired,
  title: PropTypes.shape().isRequired,
};

export default CustomTooltip;
